import {DatePickerCustomInput, ESBA_DATE_FORMAT} from 'common';
import {isBefore, min} from 'date-fns';
import React, {memo} from 'react';
import DatePicker, {ReactDatePickerProps} from 'react-datepicker';
import {Controller, useFormContext, useWatch} from 'react-hook-form';
import {Referral} from 'referral';
import {Observable} from 'rxjs';
import {useObservable} from 'rxsupport';
import {OfferFormInput} from './OfferForm';
import {toBackendDateISO, parseBackendDateISO, validateYear} from 'common/util/date';

type FirstServiceDateInputProps = {
    referral: Referral;
    isSubmitting$: Observable<boolean>;
} & Omit<ReactDatePickerProps, 'onChange'>;
export const FirstServiceDateInput = memo(({
                                               referral,
                                               isSubmitting$,
                                               ...datePickerProps
                                           }: FirstServiceDateInputProps) => {
    const {
        control,

        formState: {
            errors,
        },
    } = useFormContext<OfferFormInput>();
    const lastServiceDate = useWatch<OfferFormInput, 'lastServiceDate'>({
        control,
        name: 'lastServiceDate',
    });
    const validationRules = {
        validate: {
            beforeEndDate: (value: string | null) => {
                if (value === null) {
                    return 'This field is required.';
                }
                if (!lastServiceDate) {
                    return true;
                }
                const firstDate = parseBackendDateISO(value);
                const lastDate = parseBackendDateISO(lastServiceDate);
                if (firstDate && lastDate && isBefore(lastDate, firstDate)) {
                    return 'Must be on or before the last date you can provide all hours';
                }
                return true;
            },
            validYear: validateYear(true),
        }
    };
    const minDate = !lastServiceDate ? new Date() : min([new Date(), parseBackendDateISO(lastServiceDate) || new Date()]);


    const sending = useObservable(isSubmitting$, false);


    return (
        <Controller
            name='firstServiceDate'
            control={control}
            rules={validationRules}
            render={({field: {onChange, onBlur, value: isoValueStr}}) => <DatePicker
                {...datePickerProps}
                disabled={sending}
                onChange={(newValue: Date | null) => onChange(toBackendDateISO(newValue))}
                onBlur={onBlur}
                minDate={minDate}
                selected={isoValueStr ? parseBackendDateISO(isoValueStr) : undefined}
                dateFormat={ESBA_DATE_FORMAT}
                customInput={
                    <DatePickerCustomInput
                        width='32em'
                        label='What is the first date you can offer services?'
                        fieldName='firstServiceDate'
                        error={errors?.firstServiceDate}
                        value={isoValueStr as any}
                    />
                }
            />}
        />
    );
});
